import { Injectable } from '@angular/core';

import { IRegisterIkService } from './registerIk.service.Interface';
import { RegisterIkModel } from '../entities/registerIkModel';

@Injectable()
export class RegisterIkMockService implements IRegisterIkService {

  constructor() {}

    register(registerIk: RegisterIkModel): Promise<boolean> {
        return Promise.resolve(true);
    }

    checkUser(userToCheck: RegisterIkModel): Promise<boolean> {
      return Promise.resolve(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/account/register/services/registerIk.serviceMock.ts